import { Observable } from 'rxjs';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { UndoCommand } from './command';
import { CommandEvents } from './command-events';
import { DeclarerPointInscriptionAdministrativeCommand } from './declarer-point-inscription-administrative-command copy';

export class RetirerPointInscriptionAdministrativeCommand implements UndoCommand<ObjetMaquette> {
    private reverseCommand: DeclarerPointInscriptionAdministrativeCommand;

    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        contexteId: string,
        ignoreConflict: boolean
    ) {
        this.reverseCommand = new DeclarerPointInscriptionAdministrativeCommand(
            codeStructure,
            id,
            version,
            events,
            objetMaquetteService,
            contexteId,
            ignoreConflict
        );
    }

    do(): Observable<ObjetMaquette> {
        return this.reverseCommand.undo();
    }

    undo(): Observable<ObjetMaquette> {
        return this.reverseCommand.do();
    }

    destroy(): void {
        this.reverseCommand.destroy();
    }
}
